export default () => {
    let timerInterval, timerTimeout, lastTime;
    self.onmessage = (e) => {
        const { data } = e;

        clearInterval(timerInterval);
        clearTimeout(timerTimeout);
        switch (data) {
            case 'start':
                timerInterval = setInterval(function () {
                    var currentTime = new Date().getTime();
                    if (currentTime > lastTime + 3000 * 2) {
                        //Probably awake from sleep;
                        clearTimeout(timerTimeout);
                        postMessage(true);
                        timerTimeout = setTimeout(() => {
                            postMessage(false);
                        }, 1000);
                    }
                    lastTime = currentTime;
                }, 2500);
                break;
        }
    };
};
